'use es6';

import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Element from 'LayoutBuilderUI/components/Element';
import Placeholder from 'LayoutBuilderUI/components/Placeholder';
import ColumnDOM from 'LayoutBuilderUI/components/gridImplementations/ColumnDOM';
import { STACK, VERTICAL_ALIGN } from 'EmailEditorUI/constants/SectionLayoutConstants';
import { getElementById } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
import ElementCommentableArea from 'LayoutBuilderUI/components/utility/ElementCommentableArea';
import useColumnHeight from 'LayoutBuilderUI/hooks/useColumnHeight';
import { ElementVisibilityContextProvider } from 'LayoutBuilderUI/context/ElementVisibilityContext';
import { jsx as _jsx } from "react/jsx-runtime";
function ElementListItem({
  children,
  elementId
}) {
  const element = useSelector(state => getElementById(state, elementId));
  if (!element) {
    return null;
  }
  return /*#__PURE__*/_jsx(ElementVisibilityContextProvider, {
    styles: element.get('styles'),
    children: /*#__PURE__*/_jsx(ElementCommentableArea, {
      element: element,
      children: children
    })
  }, elementId);
}
function Column({
  canAddNewColumn,
  canResize,
  column,
  index,
  isResizing,
  isSingleColumnFullWidth,
  numColumns,
  sectionId,
  sectionIndex,
  setIsHoveringSubSection,
  stack,
  verticalAlign
}) {
  const elementsList = column.get('widgets');
  const id = column.get('id');
  const width = isSingleColumnFullWidth ? 12 : column.get('width') || 12;
  const columnHeight = useColumnHeight({
    moduleIds: elementsList
  });
  const columnIndex = stack === STACK.RIGHT_TO_LEFT ? numColumns - index - 1 : index;
  return /*#__PURE__*/_jsx(ColumnDOM, {
    canResize: canResize,
    firstElementId: elementsList.first(),
    id: id,
    index: index,
    lastElementId: elementsList.last(),
    numColumns: numColumns,
    numElements: elementsList.size,
    sectionId: sectionId,
    sectionIndex: sectionIndex,
    stack: stack,
    verticalAlign: verticalAlign,
    width: width,
    children: elementsList.size < 1 ? /*#__PURE__*/_jsx(Placeholder, {
      sectionId: sectionId,
      columnId: id
    }) : elementsList.map((elementId, i) => /*#__PURE__*/_jsx(ElementListItem, {
      elementId: elementId,
      children: /*#__PURE__*/_jsx(Element, {
        canAddNewColumn: canAddNewColumn && canResize,
        canResize: canResize,
        columnHeight: columnHeight,
        columnId: id,
        columnIndex: columnIndex,
        columnWidth: column.get('width'),
        elementId: elementId,
        index: i,
        isResizing: isResizing,
        sectionId: sectionId,
        sectionIndex: sectionIndex,
        setIsHoveringSubSection: setIsHoveringSubSection,
        stack: stack
      })
    }, elementId))
  });
}
Column.propTypes = {
  canAddNewColumn: PropTypes.bool,
  canResize: PropTypes.bool.isRequired,
  column: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  isResizing: PropTypes.bool,
  isSingleColumnFullWidth: PropTypes.bool,
  numColumns: PropTypes.number.isRequired,
  sectionId: PropTypes.string.isRequired,
  sectionIndex: PropTypes.number.isRequired,
  setIsHoveringSubSection: PropTypes.func,
  stack: PropTypes.string,
  verticalAlign: PropTypes.oneOf(Object.keys(VERTICAL_ALIGN))
};
export default Column;